import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DashboardComponent } from 'src/oldApp/pages/components/dashboard/dashboard.component';
import { DataTablesModule } from 'angular-datatables';
import { ConfigurationComponent } from 'src/oldApp/pages/components/configuration/configuration.component';
import { FormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { DatabasePanelComponent } from 'src/oldApp/pages/components/configuration/database-panel/database-panel.component';
import { CommissionConfigurationComponent } from 'src/oldApp/pages/components/commission-configuration/commission-configuration.component';
import { PipesModule } from 'src/oldApp/pipes/pipes.module';
import { CommissionDatabaseComponent } from 'src/oldApp/pages/components/commission-database/commission-database.component';
import { CommissionSimulatorComponent } from 'src/oldApp/pages/components/commission-simulator/commission-simulator.component';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { CommissionSalePromotionsComponent } from 'src/oldApp/pages/components/commission-sale-promotions/commission-sale-promotions.component';
import { ConversionConfigurationComponent } from 'src/oldApp/pages/components/conversion-configuration/conversion-configuration.component';
import { UploadBaseRefiComponent } from 'src/oldApp/pages/components/upload-base-refi/upload-base-refi.component';
import { CommissionPromoterAdditionalComponent } from 'src/oldApp/pages/components/commission-promoter-additional/commission-promoter-additional.component';
import { UploadBaseFisofoComponent } from 'src/oldApp/pages/components/commissions-fisofo/upload-base-fisofo.component';
import { CommissionFisofoConfigurationComponent } from 'src/oldApp/pages/components/commission-fisofo-configuration/commission-fisofo-configuration.component';
import { SchemeConfiguratorComponent } from 'src/oldApp/pages/components/scheme-configurator/scheme-configurator.component';
import { HibridSchemasComponent } from 'src/oldApp/pages/components/hibrid-schemas/hibrid-schemas.component';
import { HoldReleaseCommissionComponent } from 'src/app/pages/hold-release-commission/hold-release-commission.component';
import { CommissionCatPromotionsComponent } from 'src/app/pages/configurador-comisiones/commission-cat-promotions/commission-cat-promotions.component';
import { CommissionConfigPromotionsComponent } from 'src/app/pages/configurador-comisiones/commission-config-promotions/commission-config-promotions.component';
import { NominaComponent } from 'src/app/pages/nomina/reportes/nomina.component';
import { ComisionesEnvioComponent } from 'src/app/pages/nomina/comisiones-manuales/comisiones-envio/comisiones-envio.component';
import { ComisionesCargaComponent } from 'src/app/pages/nomina/comisiones-manuales/comisiones-carga/comisiones-carga.component';
import { ComisionesRetencionesComponent } from 'src/app/pages/nomina/comisiones-manuales/comisiones-retenciones/comisiones-retenciones.component';
import { ComisionesDocumentosComponent } from 'src/app/pages/nomina/comisiones-manuales/comisiones-documentos/comisiones-documentos.component';
import { PagesComponent } from 'src/app/pages/pages.component';
import { ComisionesSimuladorComponent } from './comisiones-simulador/comisiones-simulador.component';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CatCategoryPromoterComponent } from 'src/oldApp/catalogs/components/cat-category-promoter/cat-category-promoter.component';
import { ScPromoterCategoryComponent } from 'src/oldApp/catalogs/components/sc-promoter-category/sc-promoter-category.component';
import { NotFoundComponent } from 'src/oldApp/shared/not-found/not-found.component';
import { ViewHoldReleaseCommissionComponent } from './view-hold-release-commission/view-hold-release-commission.component';
import { RetencionesTablaComponent } from './view-hold-release-commission/retenciones-tabla/retenciones-tabla.component';
import { CommissionDetailHoldReleaseComponent } from './commission-detail-hold-release/commission-detail-hold-release.component';
import { PagosDistribuidorComponent } from 'src/app/pages/nomina/pagos-distribuidor/pagos-distribuidor.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfiguradorComponent } from 'src/app/pages/comisiones/configurador/configurador.component';
import { ConfiguradorV2Component } from 'src/app/pages/comisiones/configurador-v2/configurador-v2.component';
import { MatButtonModule, MatCardModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatInputModule, MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatProgressSpinnerModule, MatSelectModule, MatSlideToggleModule, MatSortModule, MatTableModule, MatTabsModule, MatTooltipModule } from '@angular/material';
import { RetencionAsesorComisionComponent } from './hold-release-commission/retencion-asesor-comision/retencion-asesor-comision.component';
import { ConsultaConfigComponent } from './comisiones/consulta/consulta-config.component';
import { ConsultaConfigV2Component } from './comisiones/consulta-v2/consulta-config-v2.component';
import { CumplimientoMetasComponent } from './comisiones/cumplimiento-metas/cumplimento-metas.component';
import { CatBusinessLineComponent } from 'src/app/pages/catalogos-comisiones/cat-business-line/cat-business-line.component';
import { CatProductComponent } from 'src/app/pages/catalogos-comisiones/cat-product/cat-product.component';
import { CatSubProductComponent } from 'src/app/pages/catalogos-comisiones/cat-sub-product/cat-sub-product.component';
import { CatTermComponent } from 'src/app/pages/catalogos-comisiones/cat-term/cat-term.component';
import { CatEmployeeJobCatalogoComponent } from 'src/app/pages/catalogos-comisiones/cat-employee-job/cat-employee-job.component';
import { CatSaleTypeComponent } from 'src/app/pages/catalogos-comisiones/cat-sale-type/cat-sale-type.component';
import { CatAgreementComponent } from 'src/app/pages/catalogos-comisiones/cat-agreement/cat-agreement.component';
import { CatEmployeesComponent } from 'src/app/pages/catalogos-comisiones/cat-employees/cat-employees.component';
import { CatPersonCreditsComponent } from 'src/app/pages/catalogos-comisiones/cat-person-credits/cat-person-credits.component';
import { CatCategoryPromoterCatalogoComponent } from 'src/app/pages/catalogos-comisiones/cat-category-promoter/cat-category-promoter.component';
import { CommissionPromoterCategoryComponent } from 'src/app/pages/catalogos-comisiones/commission-promoter-category/commission-promoter-category.component';
import { PromotorCategoryAssignmentComponent } from 'src/app/pages/catalogos-comisiones/promotor-category-assignment/promotor-category-assignment.component';
import { CatComponentsComponent } from 'src/app/pages/administracion/cat-components/cat-components.component';
import { ComponentRolesComponent } from 'src/app/pages/administracion/component-roles/component-roles.component';

@NgModule({
  declarations: [
    PagesComponent,
    DashboardComponent,
    ConfigurationComponent,
    DatabasePanelComponent,
    CommissionConfigurationComponent,
    CommissionDatabaseComponent,
    CommissionSimulatorComponent,
    CommissionSalePromotionsComponent,
    ConversionConfigurationComponent,
    UploadBaseRefiComponent,
    CommissionPromoterAdditionalComponent,
    UploadBaseFisofoComponent,
    CommissionFisofoConfigurationComponent,
    SchemeConfiguratorComponent,
    HibridSchemasComponent,
    HoldReleaseCommissionComponent,
    ViewHoldReleaseCommissionComponent,
    CommissionDetailHoldReleaseComponent,
    CommissionCatPromotionsComponent,
    CommissionConfigPromotionsComponent,
    NominaComponent,
    ComisionesEnvioComponent,
    ComisionesCargaComponent,
    ComisionesRetencionesComponent,
    ComisionesDocumentosComponent,
    ComisionesSimuladorComponent,
    PagosDistribuidorComponent,
    ConfiguradorComponent,
    ConfiguradorV2Component,
    RetencionesTablaComponent,
    RetencionAsesorComisionComponent,
    ConsultaConfigComponent,
    ConsultaConfigV2Component,
    CumplimientoMetasComponent,
    CatBusinessLineComponent,
    CatProductComponent,
    CatSubProductComponent,
    CatTermComponent,
    CatEmployeeJobCatalogoComponent,
    CatSaleTypeComponent,
    CatAgreementComponent,
    CatEmployeesComponent,
    CatPersonCreditsComponent,
    CatCategoryPromoterCatalogoComponent,
    CommissionPromoterCategoryComponent,
    PromotorCategoryAssignmentComponent,
    CatComponentsComponent,
    ComponentRolesComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgbModule,
    DataTablesModule,
    FormsModule,
    NgxMaskModule.forRoot(),
    PipesModule,
    ChartsModule,
    RouterModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatMenuModule,
    BrowserAnimationsModule,
    MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatPaginatorModule, MatSelectModule, MatSortModule, MatTableModule, MatTooltipModule
  ],
  entryComponents: [
    PagesComponent,
    HomeComponent,
    NominaComponent,
    ComisionesCargaComponent,
    ComisionesEnvioComponent,
    ComisionesDocumentosComponent,
    ComisionesRetencionesComponent,
    ComisionesSimuladorComponent,
    SchemeConfiguratorComponent,
    HoldReleaseCommissionComponent,
    ViewHoldReleaseCommissionComponent,
    CommissionDetailHoldReleaseComponent,
    CommissionCatPromotionsComponent,
    CommissionConfigPromotionsComponent,
    CatCategoryPromoterComponent,
    ScPromoterCategoryComponent,
    PagosDistribuidorComponent,
    ConfiguradorComponent,
    ConfiguradorV2Component,
    ConsultaConfigComponent,
    ConsultaConfigV2Component,
    CumplimientoMetasComponent,
    NotFoundComponent,
    CatBusinessLineComponent,
    CatProductComponent,
    CatSubProductComponent,
    CatTermComponent,
    CatEmployeeJobCatalogoComponent,
    CatSaleTypeComponent,
    CatAgreementComponent,
    CatEmployeesComponent,
    CatPersonCreditsComponent,
    CatCategoryPromoterCatalogoComponent,
    CommissionPromoterCategoryComponent,
    PromotorCategoryAssignmentComponent,
    CatComponentsComponent,
    ComponentRolesComponent,
  ],
  providers: [
    ThemeService
  ]
})
export class PagesModule {
}
